/** 业务数据管理功能 Key（CCTOWER-2768） */
export const SYS_ENUM_TYPE = {
  SERVICE_TYPE: 'SERVICE_TYPE',
  SPACE_STATUS: 'SPACE_STATUS'
} as const

/** 业务数据默认渠道，与 sys-service 缺省值一致 */
export const SYS_ENUM_DEFAULT_CHANNEL = 'CargoWareX'
